interface StepIndicatorProps {
  total: number;
  current: number | string;
  activeWidth?: number;
  dotSize?: number;
  gap?: number;
}

function Steper({ total, current, activeWidth = 24, dotSize = 8, gap = 6 }: StepIndicatorProps) {
  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap,
        borderRadius: 999,
        padding: "8px 8px 8px 0",
      }}>
      {Array.from({ length: total }, (_, i) => {
        const step = i + 1;
        const isActive = step === Number(current);
        const isDone = step < Number(current);

        return (
          <div
            key={step}
            style={{
              height: dotSize,
              width: isActive ? activeWidth : dotSize,
              borderRadius: 999,
              background: isActive ? "rgba(255,255,255,1)" : isDone ? "rgba(255,255,255,0.9)" : "rgba(255,255,255,0.35)",
              transition: "width 0.25s ease, background 0.25s ease",
            }}
          />
        );
      })}
    </div>
  );
}

export default Steper;
